<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main class="main main--has-floating-buttons">
    <tabable-card cols="12" :active-card="activeTab" :watch-active-card="true" @activeCardIndex="activeTab = $event">

      <!-- Tab 1: Report list -->
      <tabable-card-content :title="$t('pageListReports.card.listReports')">
        <hm-card-inner>
          <hm-col :grid="true" cols="12">
            <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="yesterday()">{{ $t('pageListReports.yesterday') }}</hm-button>
            <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="today()">{{ $t('pageListReports.today') }}</hm-button>
            <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="tomorrow()">{{ $t('pageListReports.tomorrow') }}</hm-button>
            <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="thisWeek()">{{ $t('pageListReports.thisWeek') }}</hm-button>
            <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="previousMonth()">{{ $t('pageListReports.previousMonth') }}</hm-button>
            <hm-button class="btn--green" cols="1@hd 2@desktop 4@tablet 12@mobile" @click="thisMonth()">{{ $t('pageListReports.thisMonth') }}</hm-button>
          </hm-col>
          <hm-input-date ref="startDate"
                         v-model="search.startDate"
                         :max-date="maxHotelDate"
                         :label="$t('pageListReports.startDate')"
                         cols="12 2@hd 2@desktop 6@tablet"
                         name="startDate" />
          <hm-input-date ref="endDate"
                         v-model="search.endDate"
                         :max-date="maxHotelDate"
                         :min-date="search.startDate"
                         :min-date-inclusive="true"
                         :max-days="-1"
                         :label="$t('pageListReports.endDate')"
                         cols="12 2@hd 2@desktop 6@tablet"
                         name="endDate" />
          <hm-input v-model="filter"
                    :lazy="false"
                    :label="$t('pageListReports.filter')"
                    name="filter"
                    cols="12 2@hd start-11@hd 3@desktop start-10@desktop 6@tablet start-7@tablet">
            <template slot="icon-inline-left" slot-scope="slot">
              <icon icon="filter" />
            </template>
            <template slot="icon-inline-right" slot-scope="slot">
              <input-icon-button v-if="!isEmpty(filter)" :border="false" icon="close-text" @click="filter = null" />
            </template>
          </hm-input>
        </hm-card-inner>
        <hm-card-inner :full-size="true">
          <paginated-table :items-per-page="25"
                           :rows="filteredRows"
                           :sticky="true"
                           min-width="600px"
                           grid-template-columns="5rem 25rem auto 20rem"
                           columns="4">
            <template slot="table-head">
              <div class="hm-table__th"></div>
              <div class="hm-table__th">{{ $t('pageListReports.search.date') }}</div>
              <sortable-th field="name">{{ $t('pageListReports.search.name') }}</sortable-th>
              <div class="hm-table__th">{{ $t('pageListReports.search.action') }}</div>
            </template>
            <template v-slot:default="slotProps">
              <template v-for="row in slotProps.currentPage">
                <div v-if="favorites.includes(row.id)" class="hm-table__td hm-table__td--no-hover color--mint cursor--pointer"><i class="fas fa-star" @click="toggleFavorite(row.id)"></i></div>
                <div v-else class="hm-table__td hm-table__td--no-hover"><i class="fal fa-star cursor--pointer" @click="toggleFavorite(row.id)"></i></div>
                <div v-if="row.dateRange === false" class="hm-table__td" @click="openReport(row.id, row)">{{ $t('pageListReports.search.allPeriods') }}</div>
                <div v-else-if="row.dateRange === 'to'" class="hm-table__td" @click="openReport(row.id, row)">{{ beginningOfTime | toDate }} - {{ search.endDate | toDate }}</div>
                <div v-else-if="row.dateRange === 'from'" class="hm-table__td" @click="openReport(row.id, row)">{{ search.startDate | toDate }} - {{ endOfTime | toDate }}</div>
                <div v-else-if="row.dayMonthOnly === true" class="hm-table__td" @click="openReport(row.id, row)">{{ search.startDate | toDayMonthDate }} - {{ search.endDate | toDayMonthDate }}</div>
                <div v-else class="hm-table__td" @click="openReport(row.id, row)">{{ search.startDate | toDate }} - {{ search.endDate | toDate }}</div>
                <div class="hm-table__td" @click="openReport(row.id, row)">{{ row.name }}</div>
                <div v-if="row.download === true" class="hm-table__td hm-table__td--icon text-right" >
                  <span class="quick-action-button" @click="openReport(row.id, row)">
                    <icon icon="download" />
                  </span>
                </div>
                <div v-else class="hm-table__td hm-table__td--icon hm-table__td--no-hover text-right" >
                  <span v-if="isEmpty(row.url) && isEmpty(row.legacy)" class="quick-action-button" @click="openReport(row.id, row, 'csv')">
                    <icon icon="download" />
                  </span>
                  <span class="quick-action-button" @click="openReport(row.id, row)">
                    <icon icon="html" />
                  </span>
                  <span class="quick-action-button" @click="openReport(row.id, row,'pdf')">
                    <icon icon="pdf" />
                  </span>
                </div>
              </template>
            </template>
          </paginated-table>
        </hm-card-inner>
      </tabable-card-content>

      <!-- Tab 2: Generated reports archive -->
      <tabable-card-content v-if="isFeatureEnabled('AsyncReportGeneration')"
                            :title="$t('pageGeneratedReports.card.title')"
                            :indicator="generatedReportsIndicator">
        <hm-card-inner>
          <hm-col :grid="true" cols="12">
            <hm-button class="btn--green" cols="2@hd 3@desktop 6@tablet 12@mobile start-1@mobile start-7@tablet start-10@desktop start-11@hd" @click="loadReports" icon-left="refresh">
              {{ $t('pageGeneratedReports.refresh') }}
            </hm-button>
          </hm-col>
        </hm-card-inner>
        <hm-card-inner :full-size="true">
          <paginated-table :items-per-page="25"
                           :hover="true"
                           :rows="reports"
                           :sticky="true"
                           min-width="700px"
                           grid-template-columns="max-content 1fr 18rem max-content max-content auto"
                           columns="6">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('pageGeneratedReports.col.requestedAt') }}</div>
              <div class="hm-table__th">{{ $t('pageGeneratedReports.col.title') }}</div>
              <div class="hm-table__th">{{ $t('pageGeneratedReports.col.requestedBy') }}</div>
              <div class="hm-table__th">{{ $t('pageGeneratedReports.col.format') }}</div>
              <div class="hm-table__th">{{ $t('pageGeneratedReports.col.status') }}</div>
              <div class="hm-table__th text-right">{{ $t('pageGeneratedReports.col.action') }}</div>
            </template>
            <template v-slot:default="slotProps">
              <template v-for="row in slotProps.currentPage">
                <template v-if="row.requestedByTenantId !== 'tenant::1' && (isEmpty(row.requiredRoles) || hasAnyRole(row.requiredRoles))">
                  <div @click="downloadReport(row)" class="hm-table__td" >{{ $moment.utc(row.requestedAt, 'YYYYMMDDHHmmss').toISOString() | toDateTime }}</div>
                  <div @click="downloadReport(row)" v-if="isEmpty(row.parameters.reportStartDate) && isEmpty(row.parameters.reportEndDate)" class="hm-table__td">{{ row.reportTitle }}</div>
                  <div @click="downloadReport(row)" v-else-if="isEmpty(row.parameters.reportStartDate) && !isEmpty(row.parameters.reportEndDate)" class="hm-table__td">{{ row.reportTitle }} (BIS {{ row.parameters.reportEndDate | toLocalDate }})</div>
                  <div @click="downloadReport(row)" v-else-if="!isEmpty(row.parameters.reportStartDate) && isEmpty(row.parameters.reportEndDate)" class="hm-table__td">{{ row.reportTitle }} (AB {{ row.parameters.reportStartDate | toLocalDate }})</div>
                  <div @click="downloadReport(row)" v-else class="hm-table__td">{{ row.reportTitle }} ({{ row.parameters.reportStartDate | toLocalDate }} - {{ row.parameters.reportEndDate | toLocalDate }})</div>
                  <div @click="downloadReport(row)" class="hm-table__td">{{ row.requestedByUserName }}</div>
                  <div @click="downloadReport(row)" class="hm-table__td">{{ row.format }}</div>
                  <div @click="downloadReport(row)" class="hm-table__td">
                    <i :class="[statusIcon(row.status), statusClass(row.status)]" />
                  </div>
                  <div @click="downloadReport(row)" v-if="row.status === 'Ready'" class="hm-table__td hm-table__td--icon text-right">
                    <span class="quick-action-button">
                      <icon v-if="row.format === 'PDF'" icon="pdf" />
                      <icon v-else-if="row.format === 'HTML'" icon="html" />
                      <icon v-else icon="download" />
                    </span>
                  </div>
                  <div v-else-if="row.status === 'Processing' || row.status === 'Pending'"
                       class="hm-table__td text-right">
                    <span style="padding-right: 1.6rem">
                      <i class="fa-duotone fa-solid fa-spinner fa-spin" />
                    </span>
                  </div>
                  <div v-else class="hm-table__td">&nbsp;</div>
                </template>
              </template>
            </template>
          </paginated-table>
        </hm-card-inner>
      </tabable-card-content>

    </tabable-card>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil, isEmpty, lowerCase, remove, sortBy, keyBy } from 'lodash';
import PageMixin from '../../mixins/PageMixin';
import Reports from '@/lib/reports';

const QUICK_OPEN_TIMEOUT_MS = 30000;
const POLL_INTERVAL_MS = 2000;

export default {
  name: 'PageListReports',

  mixins: [HotelmeisterMixin, PageMixin],

  data() {
    return {
      search: {
        startDate: null,
        endDate: null,
      },
      filter: null,
      favorites: [],
      pageLoaded: false,
      beginningOfTime: '19700101',
      endOfTime: '20991231',
      activeTab: 0,
      reports: [],
    };
  },

  computed: {
    maxHotelDate: function () {
      return this.$moment().add(this.hotelSettings.details.futureDates, 'days').format('YYYYMMDD');
    },
    filteredRows: function () {
      let ret = this.rows;

      if (!isEmpty(this.filter)) {
        ret = ret.filter(it => Object.values(it).filter(str => !isEmpty(str) && !isEmpty(str) && (typeof str === 'string' ? str.toLowerCase() : lowerCase(str)).indexOf(this.filter.toLowerCase()) >= 0).length > 0);
      }

      return ret;
    },
    rows: function () {
      // required for eval
      const hasLicense = this.hasLicense;
      const hasRole = this.hasRole;
      const hotelSettings = this.hotelSettings;

      return sortBy(
        // eslint-disable-next-line
        Reports.list
          .filter((it) => {
            if (isEmpty(it.condition)) {
              return this.hasRole('ROLE_USER');
            } else if (!it.condition.includes('hasRole')) {
              // eslint-disable-next-line no-eval
              return eval(it.condition) && this.hasRole('ROLE_USER');
            } else {
              // eslint-disable-next-line no-eval
              return eval(it.condition);
            }
          })
          .map(it => ({
            ...it,
            name: this.$t(`reports.${it.id}`),
            favorite: this.favorites.includes(it.id) ? 1 : 999,
          })),
        ['favorite', 'name'],
      );
    },
    reportsById: function () {
      return keyBy(this.rows, 'id');
    },
    generatedReportsIndicator: function () {
      if (this.reports.some(r => r.status === 'Processing' || r.status === 'Pending')) return 'orange';
      // if (this.reports.some(r => r.status === 'READY')) return 'green';
      return null;
    },
  },

  watch: {
    favorites: function () {
      localStorage.setItem(`${this.$root.hotel}__${this.$root.username}__reportFavorites`, JSON.stringify(this.favorites));
    },
  },

  created: function () {
    this.favorites = JSON.parse(localStorage.getItem(`${this.$root.hotel}__${this.$root.username}__reportFavorites`) || '[]') || [];
    this.today();
    this.loadReports();
    this.$serviceBus.$on('generatedReports.refresh', this.loadReports);
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('generatedReports.refresh', this.loadReports);
  },

  methods: {
    toggleFavorite: function (reportId) {
      if (this.favorites.includes(reportId)) {
        this.favorites = remove(this.favorites, it => it !== reportId);
      } else {
        this.favorites.push(reportId);
      }
    },
    openReport: function (reportId, reportRow, format = null) {
      const report = this.reportsById[reportId];

      let params = {};

      if (!isNil(reportRow.params)) {
        Object.assign(params, reportRow.params);
      }

      let url;
      if (!isEmpty(report.legacy)) {
        url = `/rest/ui/backend${this.serviceUrls.report.legacy(this, report.legacy)}.html`;
      } else if (!isEmpty(report.url)) {
        url = `/pages/reports${report.url}`;
      } else {
        url = `/rest/ui/backend${this.serviceUrls.report.get(this, reportId)}`;
      }

      if (report.dateRange !== false) {
        switch (report.dateRange) {
          case 'to':
            params.reportEndDate=this.search.endDate;
            url = `${url}?reportEndDate=${this.search.endDate}`;
            break;
          case 'from':
            params.reportStartDate=this.search.startDate;
            url = `${url}?reportStartDate=${this.search.startDate}`;
            break;
          default:
            params.reportStartDate=this.search.startDate;
            params.reportEndDate=this.search.endDate;
            url = `${url}?reportStartDate=${this.search.startDate}&reportEndDate=${this.search.endDate}`;
            break;
        }
      }

      if (!isNil(report.params)) {
        Object.entries(report.params).forEach(([key, value]) => {
          url = `${url}${url.includes('?') ? '&' : '?'}${key}=${value}`;
        });
      }

      if (format === 'csv' && !url.includes('accept=text/csv')) {
        url = `${url}${url.includes('?') ? '&' : '?'}accept=text/csv`;
        params.outputType = 'csv';
      }

      if (format === 'pdf') {
        url = `${url}${url.includes('?') ? '&' : '?'}outputType=pdf`;
        params.outputType = 'pdf';
      }

      if (!isEmpty(reportRow.legacy) && report.download) {
        params.outputType = "zip";
      }

      // Sync fallback: when AsyncReportGeneration toggle is OFF, open the report directly
      // (original behaviour — no polling, no S3, no GeneratedReport record).
      if (!this.isFeatureEnabled('AsyncReportGeneration')) {
        url = `${url}${url.includes('?') ? '&' : '?'}title=${encodeURI(report.name)}`;

        window.openOldUI(
          isEmpty(report.url) ? 'report' : this.hotelSettings.tenant.subdomain,
          this.hotelSettings.hotel.id,
          url,
          window.getToken(this.$root.hotel),
          this.$shortLocale === 'de' ? this.$shortLocale : 'en',
        );
        return;
      }

      let asyncUrl;
      if (!isEmpty(reportRow.legacy)) {
        asyncUrl = this.serviceUrls.report.generateLegacy(this, reportRow.legacy);
      } else {
        asyncUrl = this.serviceUrls.report.generate(this, reportRow.id);
      }

      params.title = reportRow.name;

      this.axios.post(asyncUrl, {}, { params: params })
        .then((response) => {
          const generatedReportId = response.data && response.data.data && response.data.data.generatedReportId;

          this.$notify({
            group: 'msg',
            title: this.$t('pageListReports.scheduleSuccess'),
            type: 'success',
            duration: 4000,
          });

          if (!generatedReportId) return;

          // Poll for up to 30 seconds; if ready, auto-open so the user sees no difference
          // from the old synchronous behaviour. If it takes longer, switch to the archive tab.
          const startTime = Date.now();
          const poll = setInterval(() => {
            if (Date.now() - startTime >= QUICK_OPEN_TIMEOUT_MS) {
              clearInterval(poll);
              this.loadReports();
              // this.activeTab = 1; // don't switch tabs, might cause unexpected behaviour if a user is requesting multiple reports
              return;
            }
            this.axios.get(this.serviceUrls.report.downloadGenerated(this, generatedReportId))
              .then((downloadResponse) => {
                const downloadUrl = downloadResponse.data && downloadResponse.data.data && downloadResponse.data.data.downloadUrl;
                if (downloadUrl) {
                  clearInterval(poll);
                  window.open(downloadUrl, '_blank');
                  this.loadReports();
                }
              })
              .catch((err) => {
                // 409 = not ready yet, keep polling; anything else = stop
                if (!err.response || err.response.status !== 409) {
                  clearInterval(poll);
                  this.loadReports();
                }
              });
          }, POLL_INTERVAL_MS);
        })
        .catch(() => {
          this.showErrorMessage(this.$t('pageListReports.scheduleError'));
        });
    },
    loadReports() {
      this.axios.get(this.serviceUrls.report.listGenerated(this))
        .then((response) => {
          this.reports = isNil(response.data.data) ? [] : response.data.data;
        })
        .catch(() => {
          this.showErrorMessage(this.$t('pageGeneratedReports.loadError'));
        });
    },
    downloadReport(generatedReport) {
      if (generatedReport.status !== 'Ready') {
        this.showErrorMessage(this.$t('pageGeneratedReports.notReadyError'));
        return;
      }
      this.axios.get(this.serviceUrls.report.downloadGenerated(this, generatedReport.id))
        .then((response) => {
          const downloadUrl = response.data.data && response.data.data.downloadUrl;
          if (downloadUrl) {
            window.open(downloadUrl, '_blank');
          }
        })
        .catch(() => {
          this.showErrorMessage(this.$t('pageGeneratedReports.downloadError'));
        });
    },
    statusIcon(status) {
      switch (status) {
        case 'Ready': return 'fal fa-check';
        case 'Failed': return 'fal fa-exclamation-triangle';
        default: return 'fal fa-clock';
      }
    },
    statusClass(status) {
      switch (status) {
        case 'Ready': return 'color--mint';
        case 'Failed': return 'color--red';
        default: return 'color--warn';
      }
    },
    yesterday() {
      this.jumpToDate(-1);
    },
    today() {
      this.jumpToDate(0);
    },
    tomorrow() {
      this.jumpToDate(1);
    },
    jumpToDate(offset) {
      this.search.startDate = this.$moment().add(offset, 'days').format('YYYYMMDD');
      this.$nextTick(() => {
        this.search.endDate = this.$moment().add(offset, 'days').format('YYYYMMDD');
        if (this.pageLoaded === true) {
          this.$refs.startDate.glow();
          this.$refs.endDate.glow();
        } else {
          this.pageLoaded = true;
        }
      });
    },
    thisWeek() {
      this.jumpToPeriod(0, 'week');
    },
    previousWeek() {
      this.jumpToPeriod(-1, 'week');
    },
    thisMonth() {
      this.jumpToPeriod(0, 'month');
    },
    previousMonth() {
      this.jumpToPeriod(-1, 'month');
    },
    jumpToPeriod(offset, quantifier) {
      this.search.startDate = this.$moment().add(offset, quantifier).startOf(quantifier).format('YYYYMMDD');
      this.$nextTick(() => {
        this.search.endDate = this.$moment().add(offset, quantifier).endOf(quantifier).format('YYYYMMDD');
        this.$refs.startDate.glow();
        this.$refs.endDate.glow();
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageListReports.vue